export default "__VITE_ASSET__BVl9HLou__"